var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list-item',{attrs:{"link":""},on:{"click":function($event){return _vm.$router.push('visual-voicemail')}}},[_c('v-list-item-action',[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("mdi-audio-video")])],1),_c('v-list-item-subtitle',[_vm._v("Visual Voicemail")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }